<template>
  <!-- out which, I am only applying Bootstrap to pages which use it -->

  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
    crossorigin="anonymous"
  />
  <!-- See: `getFullVh()` -->
  <div style="overflow: hidden; height: 0">
    <div id="measure-vh" style="position: fixed; height: 100vh"></div>
  </div>

  <!-- showPopUpOk --><transition name="fade">
    <div
      v-show="showPopUpOk"
      class="modal-overlayfrombottomblur"
      :class="this.showOld === true ? 'wrapper-todiv' : 'wrapper-todiv-new'"
      style="z-index: 999"
    >
      <div
        class="modalnotbootstrap"
        style="
          padding-top: 3vh;
          padding-bottom: 3vh;
          min-height: 40vh;
          width: 80%;
        "
      >
        <!-- put in table for dev speed need to learn more about flex -->
        <table border="0" width="80%">
          <tr>
            <td>
              <div
                class="lt-blue txtc"
                :style="{
                  'font-size': this.fontSizeTitle + 'vh',
                  'line-height': this.fontSizeTitleLineHeight + 'vh',
                }"
              >
                {{ this.popUpMsgTitle }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="lt-blue txtc"
                :style="{
                  'font-size': this.fontSizePopUpMsg + 'vh',
                  'line-height': this.fontSizePopUpMsgLineHeight + 'vh',
                  'padding-top': '1vh',
                }"
                style="overflow-wrap: anywhere"
              >
                {{ this.popUpMsgBody }}
              </div>
            </td>
          </tr>
          <tr v-show="!this.suppressOk">
            <td style="height: 10vh">
              <div>
                <button
                  class="widebtn"
                  ref="show-popup-ok"
                  style="width: 50%; height: 6vh"
                  @click="this.doPopUpOk()"
                >
                  Ok
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <!-- spacer -->
            <td><div></div></td>
          </tr>
        </table>
      </div>
    </div>
  </transition>
  <div>
    <!-- how or dont show whole new home page -->

    <div
      class="container text-center"
      style="padding: 0vw; outline: 0.0em dashed orange"
    >
      <NavigationBar
        @do-show-home="doShowHome"
        @do-show-gettipsstart="doShowGetTipsStartNew"
        @do-show-givetips="doGiveTipsShowMoreInfoNew"
        @do-show-gettips="doGetTipsShowMoreInfoNew"
        @do-show-tipwithoutscanning="doShowTipWithoutScanning"
        @do-show-account="doShowAccount"
        @do-download-brochure="doDownloadBrochure"
        @do-show-contact="doShowContactNew"
      />

      <div
        class="jumbotron text-center tugradient1"
        style="outline: 0.0em dashed red"
      >
        <div
          class="container mediaSelectDesktop"
          style="padding: 3vw; outline: 0.0em dashed blue"
        >
          <div class="row" style="outline: 0.0em dashed pink">
            <div v-if="this.nhbfmembers === true"
              class="offset-md-4 col-md-8 tufont tublue tumediumtitlebold tubestsolutiontitle text-middle"
              style="outline: 0.0em dashed purple; height: 60px "
            >
              Welcome NHBF member...
            </div>
            <div
              class="col-md-4 mainimageheight hairdresser2imagewidth "
              style="display: flex; flex-wrap: wrap; outline: 0.0em dashed green"
            >
              <img
                class="hairdresser2imagewidth fade-in-button-animation"
                style="
                  height: auto;
                  padding-top: 0vw;
                  padding-bottom: 1.5vw;
                  outline: 0.0em dashed purple;
                "
                alt="Hairdresser"
                src="../assets/hairdresser2.webp"
              />
              <span class="mediaSelectDesktop tufont tusmallerfontsize">
                If one of our standard packages below does not suit your
                needs, simply let us know your requirements.</span
              >
            </div>

            <!-- <div class="col-sm-8 col-md-8 text-start" style="padding-left: 3vw; padding-right: 6vw; outline:0.0em dashed orange; height: auto"> -->

            <div
              class="col-8 col-md-8 tufont tumediumtitlebold tubestsolutiontitle text-middle transparent-simple-animation"
              style="outline: 0.0em dashed purple; height: auto"
            >
              Getting set up with ThankU is this easy!
            </div>
            <HomePageTickedListItem
              ListItemString="Decide below which ThankU QR media you would like"
            />
            <HomePageTickedListItem
              :ListItemString="useNewOrderForm ? 'Click a \'Get set up!\' button to proceed with your order' : 'Click a \'Get set up for free!\' button, for your media at no cost'"
            />
            <HomePageTickedListItem
              ListItemString="Complete the form below to tell us your selection and where to send the media"
            />
            <HomePageTickedListItem
              ListItemString="We send you your ThankU QR media by post, and a staff set up email"
            />
            <HomePageTickedListItem
              ListItemString="Staff connect themselves to get ready for tips in 1 minute each"
            />
          </div>
          <br />

          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-start tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-10 offset-md-1 tufont;"
              style="outline: 0.0em dashed green"
            >
              <div
                class="bottombuttonwidth"
                style="padding-top: 1vh; margin: auto"
              >
                <span></span
                ><button
                  class="tuhomepagesignupbutton turegularfontsize fade-in-button-animation"
                  style="width: 100%"
                  @click="this.doOrderBadges()"
                >
                  {{ useNewOrderForm ? 'Get set up!' : 'Get set up for free!' }}
                </button>
              </div>
            </span>
          </div>
          <div class="mediaSelectDesktop">
            <div
              class="container"
              style="padding: 3vw; outline: 0.0em dashed blue"
            >
              <div class="row" style="outline: 0.0em dashed pink"></div>
            </div>
            <div class="row" style="height: 0vw !important">
              <div class="col-md-1" style="outline: 0.0em dashed green">
                <img
                  class="smile1"
                  alt="ThankU smile right"
                  src="../assets/tusmileonly.png"
                />
              </div>
              <div class="col-md-1" style="outline: 0.0em dashed green">
                <img
                  class="smile2"
                  alt="ThankU smile right"
                  src="../assets/tusmileonly.png"
                />
              </div>
            </div>
          </div>
          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-center tusmallerfontsize"
            style="
              outline: 0.0em dashed red;
              height: auto;
              padding-top: 1vh;
              margin-top: -6vw;
            "
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="padding-top: 1.5vw; outline: 0.0em dashed green"
            >
              <template v-if="!useNewOrderForm">
                ThankU is currently providing its ThankU QR badge media to you
                <b>free of charge</b> for a limited time only on your first order. Simply tell us how
                many of each format you would like, and the address to send them
                to - that's it!
              </template>
              <template v-else>
                Select your ThankU QR badge media below and we'll send it to you promptly. 
                Simply choose what you need and complete your order!
              </template>
            </span>
          </div>
          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-center tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="padding-top: 0vw; outline: 0.0em dashed green"
            >
              Fees are payable on tip transactions, most often paid by the
              tipper, but when not, fees are deducted from the tip. For FAQ on
              recieving tips, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >, and full information specifically on fees, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoFeesNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >.
            </span>
            <div
              class="col-12 tufont tutablepadding tusmallerfontsize"
              style="
                outline: 0.0em dashed red;
                height: auto;
                float: left;
                padding-top: 1vh;
              "
            >
              <button
                class="tuhomepagebutton turegularfontsize fade-in-button-animation"
                @click="this.doDownloadBrochure()"
              >
                Download our brochure
              </button>
            </div>
          </div>
        </div>
        <div
          class="container mediaSelectPhone"
          style="padding: 3vw; outline: 0.0em dashed blue"
        >
          <div class="mediaSelectPhone container">
            <div class="row" style="display: none; outline: 0.0em dashed pink">
              <div
                class="offset-0 col-3"
                style="height: 0px; outline: 0.0em dashed green"
              >
                <img
                  class="smile1"
                  style="outline: 0.5em dashed green"
                  alt="ThankU smile"
                  src="../assets/tusmileonly.png"
                />
              </div>

              <div>&nbsp;</div>

              <div
                class="offset-0 col-12 float-right"
                style="height: 0px; outline: 0.0em dashed green"
              >
                <img
                  class="smile2"
                  alt="ThankU smile"
                  src="../assets/tusmileonly.png"
                />
              </div>
            </div>
          </div>
          <div v-if="this.nhbfmembers === true"
            class="col-12 tufont tublue tumediumtitlebold tubestsolutiontitle text-middle"
            style="outline: 0.0em dashed purple; height: 60px "
          >
            Welcome NHBF member...
          </div>
          <div
            class="row"
            style="display: flex; flex-wrap: wrap; outline: 0.0em dashed pink"
          >
            <div
              class="col-7 offset-0 mainimageheight hairdresser2imagewidth"
              style="display: flex; flex-wrap: wrap; outline: 0.0em dashed green"
            >
              <img
                class="hairdresser2imagewidth fade-in-button-animation"
                style="
                  height: auto;
                  padding-top: 0vw;
                  padding-bottom: 1.5vw;
                  outline: 0.0em dashed purple;
                "
                alt="Hairdresser"
                src="../assets/hairdresser2.webp"
              />
              <span class="mediaSelectDesktop tufont tusmallerfontsize">
                <br />If one of our standard packages below does not suit your
                needs, simply let us know your requirements.</span
              >
            </div>

            <div
              class="col-5 tufont tumediumtitleboldbigger text-middle transparent-simple-animation"
              style="
                outline: 0.0em dashed purple;
                padding-left: 0vw;
                height: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              Getting set up with ThankU is this easy!
            </div>

            <!-- <div class="col-sm-8 col-md-8 text-start" style="padding-left: 3vw; padding-right: 6vw; outline:0.0em dashed orange; height: auto"> -->

            <HomePageTickedListItem
              ListItemString="Decide below which ThankU QR media you would like"
            />
            <HomePageTickedListItem
              :ListItemString="useNewOrderForm ? 'Click a \'Get set up!\' button to proceed with your order' : 'Click a \'Get set up for free!\' button, for your media at no cost'"
            />
            <HomePageTickedListItem
              ListItemString="Complete the form below to tell us your selection and where to send the media"
            />
            <HomePageTickedListItem
              ListItemString="We send you your ThankU QR media by post, and a staff set up email"
            />
            <HomePageTickedListItem
              ListItemString="Staff connect themselves to get ready for tips in 1 minute each"
            />
          </div>
          <br />

          <div
            class="row col-12 col-md-8 offset-md-4 tufont tutablepadding text-start tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-10 offset-md-1 tufont;"
              style="outline: 0.0em dashed green"
            >
              <div
                class="bottombuttonwidth"
                style="padding-top: 1vh; margin: auto"
              >
                <span></span
                ><button
                  class="tuhomepagesignupbutton turegularfontsize fade-in-button-animation"
                  style="width: 100%"
                  @click="this.doOrderBadges()"
                >
                  {{ useNewOrderForm ? 'Get set up!' : 'Get set up for free!' }}
                </button>
              </div>
            </span>
          </div>
          <div
            class="row col-12 col-md-8 offset-md-4 tufont text-center tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="
                padding-top: 1.5vw;
                padding-left: 0vw;
                padding-right: 0vw;
                outline: 0.0em dashed green;
              "
            >
              <template v-if="!useNewOrderForm">
                ThankU is currently providing its ThankU QR badge media to you
                <b>free of charge</b> for a limited time only. Simply tell us how
                many of each format you would like, and the address to send them
                to - that's it!
              </template>
              <template v-else>
                Select your ThankU QR badge media below and we'll send it to you promptly. 
                Simply choose what you need and complete your order!
              </template>
            </span>
          </div>
          <div
            class="row col-12 col-md-8 offset-md-4 tufont text-center tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="
                padding-top: 1.5vw;
                padding-left: 0vw;
                padding-right: 0vw;
                outline: 0.0em dashed green;
              "
            >
              Fees are payable on tip transactions, most often paid by the
              tipper, but when not, fees are deducted from the tip. For FAQ on
              recieving tips, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >, and full information specifically on fees, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoFeesNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >.
            </span>
          </div>
          <div
            class="col-12 tufont tusmallerfontsize"
            style="
              outline: 0.0em dashed red;
              height: auto;
              padding-top: 1vh;
              padding-left: 0vw;
              padding-right: 0vw;
              outline: 0.0em dashed green;
            "
          >
            <button
              class="tuhomepagebutton turegularfontsize tugettipspagebuttonwidth fade-in-button-animation"
              @click="this.doDownloadBrochure()"
            >
              Download our brochure
            </button>
          </div>
        </div>
        <div class="container" style="padding-top: 1vw">
          <div class="row">
            <div
              class="col-12 offset-0 col-md-12 offset-md-0 tuwhitebox"
              style="width: 90vw; margin: auto; outline: 0.0em dotted black"
            >
              <div class="tufont tumediumtitlebold">Regular package</div>
              <div
                class="col-md-8 offset-md-2 tufont tusmallerfontsize"
                style="padding-top: 1vw; padding-bottom: 1vw"
              >
                This package is widely used in salons, however we have a number
                of options other than 'stylist', including 'therapist',
                'technician', 'nail technician, 'nail tech', 'nail stylist', 'artist', 'host', 'waiter', 'bar staff', 'driver', 'team', 'guide', 'trainer', or
                non-specific.
              </div>
              <div
                class="container"
                style="
                  display: flex;
                  flex-wrap: wrap;
                  outline: 0.0em dashed green;
                "
              >
                <div class="col-12 col-md-6" style="outline: 0.0em dashed pink">
                  <table
                    class="table"
                    border="0"
                    style="width: 100%; outline: 0.0em dashed red"
                  >
                    <tr>
                      <td
                        style="padding-bottom: 0.2vw; outline: 0.0em dashed pink"
                      >
                        Front Desk Stand
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0.0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          Typically placed at your reception / payments desk,
                          our stylish Front Desk Stand announces to your clients
                          that you have a tipping service available for them.
                          Dimensions: 14.8 x 10.5cm.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a v-bind:href="frontdeskfull"
                          ><img
                            class="productImageWidth"
                            style="
                              height: auto;
                              padding-top: 0vw;
                              outline: 0.0em dashed purple;
                            "
                            alt="Window sticker"
                            src="../assets/frontdesklessrounded.webp"
                          />
                        </a>
                      </td>
                    </tr>
                  </table>
                </div>

                <div class="col-12 col-md-6" style="outline: 0.0em dashed red">
                  <table
                    class="table"
                    border="0"
                    style="width: 100%; outline: 0.0em dashed red"
                  >
                    <tr>
                      <td
                        style="padding-bottom: 0.2vw; outline: 0.0em dashed pink"
                      >
                        <b>Optional:</b> "No Glue" Mirror Sticker
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0.0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b>At your option:</b> mount our "No Glue" Mirror
                          Stickers on the mirror in front of the client. Some
                          salons choose this option, others do not, it's a
                          matter of personal preference.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a v-bind:href="stickerfull"
                          ><img
                            class="productImageWidth"
                            style="
                              height: auto;
                              padding-top: 0vw;
                              outline: 0.0em dashed purple;
                            "
                            alt="Window sticker"
                            src="../assets/stickerrounded.webp"
                          />
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b>How to mount:</b> adheres to the surface of
                          client-facing mirror without adhesive and is easily
                          removable – simply moisten glass of mirror with damp
                          kitchen roll or similar, then mount the 'sticker' on
                          the glass, gently pressing out any obvious bubbles
                          with your finger – dab any remaining moisture on the
                          surface of the sticker or mirror away if necessary.
                          Dimensions: 12cm x 8cm.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b
                            >We also have wristworn and stickable ThankU QR
                            media, please phone or email us to find out more.</b
                          >
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
            <div
              class="col-md-6 offset-md-2 tuwhitebox discreetpackagephonewidth"
              style="margin-top: 3vw !important; padding-top: 1vw; outline: 0.0em dotted black"
            >
              <div class="tufont tumediumtitlebold" style="padding-bottom: 1vw">
                Discrete package
              </div>

              <div class="container">
                <div class="col-12 col-md-12" style="outline: 0.0em dashed red">
                  <table
                    border="0"
                    style="width: 100%; outline: 0.0em dashed red"
                  >
                    <tr>
                      <td style="padding-bottom: 1vw">Tabletop Stand</td>
                    </tr>

                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0.0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          If you just want to keep the presentation of thankU
                          very discreet, use our sleek Tabletop Stand instead of
                          the Front Desk Stand, which you can direct your
                          clients to if they ask how they can tip. Dimensions:
                          6cm x 4.3cm.
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <a v-bind:href="countersquarefull"
                          ><img
                            class="productImageWidthCountertop"
                            style="
                              height: auto;
                              padding-top: 0vw;
                              outline: 0.0em dashed purple;
                            "
                            alt="Window sticker"
                            src="../assets/countersquarerounded.webp"
                          />
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          We supply up to 3 Tabletop Stands at no charge.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 0.3vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b
                            >We also have wearable and stickable ThankU QR
                            media, based on the blue ThankU QR badge shown above
                            - please phone or email us to find out more.</b
                          >
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref="orderForm"></div>
       
        
        <!-- OLD ORDER FORM -->
        <div
          v-show="!useNewOrderForm && this.showOrderForm === true"
          class="col-md-8 offset-md-2 tugreybluebox orderformphonewidth"
          style="margin-top: 3vw !important; outline: 0.0em dotted black"
        >
          <table style="width: 100%; "> <!-- background: #6bc720 -->
            <tr>
              <td>
                <div class="tufont tumediumtitlebold">
                  Order your free ThankU QR media
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="tufont tusmallerfontsize">
                  We currently supply your <u>first</u> order at no cost, if you would like to place an additional media order, please <a href="#" @click.prevent="doToggleToPaidForm">click here</a>.
                  <!-- We currently supply your <u>first</u> order at no cost, if you would like to place an additional media order, please use this form and we will supply you with a quotation. -->
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%; "
                      ref="changePackage"
                      @change="doDetectSelectChangePackage()"
                    >
                      <option value="regular">
                        -- Choose ThankU QR media package --
                      </option>
                      <option value="regular">
                        Regular ThankU QR media package
                      </option>
                      <option value="discreet">
                        Discreet ThankU QR media package
                      </option>
                      <option value="custom">
                        Custom - tell us in the Notes box below
                      </option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeBusinessType"
                      @change="doDetectSelectChangeBusinessType()"
                    >
                      <option value="salon">
                        -- Select your business type --
                      </option>
                      <option value="salon">Salon</option>
                      <option value="hotel">Hotel</option>
                      <option value="restaurant">Restaurant</option>
                      <option value="pub">Pub</option>
                      <option value="other">Other</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeDescriptionRecipient"
                      @change="doDetectSelectChangeDescriptionRecipient()"
                    >
                      <option value="stylist">
                        -- Select description for main type of recipient --
                      </option>
                      <option value="stylist">Stylist</option>
                      <option value="therapist">Therapist</option>
                      <option value="technician">Technician</option>
                      <option value="nailtechnician">Nail Technician (out of stock)</option>
                      <option value="nailtech">Nail Tech</option>
                      <option value="nailstylist">Nail Stylist</option>
                      <option value="artist">Artist</option>
                      <option value="host">Host</option>
                      <option value="waiter">Waiter</option>
                      <option value="barstaff">Bar Staff</option>
                      <option value="driver">Driver</option>
                      <option value="team">Team</option>
                      <option value="guide">Guide</option>
                      <option value="trainer">Trainer</option>
                      <option value="non-specific">Non-specific</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr v-show="this.showStickers === true">
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeNumberOfStickers"
                      @change="doDetectSelectChangeNumberOfStickers()"
                    >
                      <option value="0">
                        -- Select number of "No Glue" Mirror Stickers --
                      </option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">More than 30</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr v-show="this.showTableTop === true">
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeNumberOfTabletopStands"
                      @change="doDetectSelectChangeNumberOfTabletopStands()"
                    >
                      <option value="regular">
                        -- Select number of Tabletop Stands --
                      </option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">More than 3</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 12vh; display: flex; padding-bottom: 0vw"
                  >
                    <textarea
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="height: 12vh; max-width: 100%; width: 100%"
                      ref="orderNotes"
                      placeholder="Notes - if you need to let us know more about your requirements."
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderName"
                      placeholder="Your name"
                    />
                  </span>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderBusinessName"
                      placeholder="Name of your business"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="text"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderAddressLine1"
                      autocomplete="address-line1"
                      placeholder="Address line 1"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="text"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderAddressLine2"
                      autocomplete="address-line2"
                      placeholder="Address line 2 (optional)"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="text"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderAddressCity"
                      autocomplete="address-level2"
                      placeholder="City"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="text"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderAddressPostcode"
                      autocomplete="postal-code"
                      placeholder="Postcode"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="email"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderEmail"
                      placeholder="Your email address"
                    />
                  </span>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderPhoneNumber"
                      placeholder="Optional: your phone number"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td style="display: flex">
                <div
                  class="lt-blue notes-text"
                  style="width: 90%; padding-top: 0vw"
                >
                  Your email address and phone number are <b>never</b> shared
                  with anyone
                </div>
                <br />
              </td>
            </tr>

            <tr>
              <td style="display: flex">
                <div
                  class="lt-blue notes-text"
                  style="width: 90%; padding-top: 0vw"
                >
                  <b>Any questions?</b> Please call us on +442078560378 or email
                  us at
                  <a
                    href="mailto:mailorders@thanku.app?subject=get ThankU enquiry&body=Please let us know your query or requirements: %0D%0A%0D%0A%0D%0AThank you! best wishes, the ThankU Team"
                    >mailorders@thanku.app</a
                  >
                </div>
                <br />
              </td>
            </tr>
            <tr>
              <td style="height: 12vh">
                <div>
                  <button
                    class="tuhomepagebutton tugettipspagebuttonwidth"
                    @click="this.doSubmitOrder()"
                  >
                    Submit your order
                  </button>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <!-- NEW ORDER FORM -->
        <div
          v-show="useNewOrderForm && this.showOrderForm === true"
          class="new-order-form-container"
        >
          <div class="new-order-form">
            <h2 class="form-title">Build Your Order</h2>
            
            <div class="order-items">
              <!-- Front Desk Stand -->
              <div class="order-item" :class="{ 'item-selected': orderItems.frontDesk.quantity > 0 }">
                <div class="item-image" @click="openImageLightbox(require('@/assets/pos2croppedsm2.webp'))" style="cursor: pointer;">
                  <img src="../assets/pos2croppedsm2.webp" alt="Front Desk Stand">
                </div>
                <div class="item-details">
                  <h3 class="item-name">Front Desk Stand</h3>
                  <p class="item-description">Stylish stand for your reception desk (14.8 x 10.5cm)</p>
                  <div class="item-price">£{{ orderItems.frontDesk.price.toFixed(2) }}</div>
                </div>
                <div class="item-controls">
                  <button 
                    class="qty-btn" 
                    @click="decrementItem('frontDesk')"
                    :disabled="orderItems.frontDesk.quantity === 0"
                  >−</button>
                  <span class="qty-display">{{ orderItems.frontDesk.quantity }}</span>
                  <button class="qty-btn" @click="incrementItem('frontDesk')">+</button>
                </div>
              </div>

              <!-- Mirror Stickers -->
              <div class="order-item" :class="{ 'item-selected': orderItems.mirrorStickers.quantity > 0 }">
                <div class="item-image" @click="openImageLightbox(require('@/assets/stickerrounded.webp'))" style="cursor: pointer;">
                  <img src="../assets/stickerrounded.webp" alt="Mirror Stickers">
                </div>
                <div class="item-details">
                  <h3 class="item-name">"No Glue" Mirror Stickers</h3>
                  <p class="item-description">Removable stickers for client mirrors (12cm x 8cm)</p>
                  <div class="item-price">£{{ orderItems.mirrorStickers.price.toFixed(2) }}</div>
                </div>
                <div class="item-controls">
                  <button 
                    class="qty-btn" 
                    @click="decrementItem('mirrorStickers')"
                    :disabled="orderItems.mirrorStickers.quantity === 0"
                  >−</button>
                  <span class="qty-display">{{ orderItems.mirrorStickers.quantity }}</span>
                  <button class="qty-btn" @click="incrementItem('mirrorStickers')">+</button>
                </div>
              </div>

              <!-- Tabletop Stands -->
              <div class="order-item" :class="{ 'item-selected': orderItems.tabletopStands.quantity > 0 }">
                <div class="item-image" @click="openImageLightbox(require('@/assets/countersquare.webp'))" style="cursor: pointer;">
                  <img src="../assets/countersquaresm.webp" alt="Tabletop Stand">
                </div>
                <div class="item-details">
                  <h3 class="item-name">Tabletop Stand</h3>
                  <p class="item-description">Discreet stand for countertops (6cm x 4.3cm)</p>
                  <div class="item-price">£{{ orderItems.tabletopStands.price.toFixed(2) }}</div>
                </div>
                <div class="item-controls">
                  <button 
                    class="qty-btn" 
                    @click="decrementItem('tabletopStands')"
                    :disabled="orderItems.tabletopStands.quantity === 0"
                  >−</button>
                  <span class="qty-display">{{ orderItems.tabletopStands.quantity }}</span>
                  <button class="qty-btn" @click="incrementItem('tabletopStands')">+</button>
                </div>
              </div>
            </div>

            <!-- Order Summary -->
            <div class="order-summary" v-show="totalItems > 0">
              <div class="summary-row">
                <span>Items ({{ totalItems }})</span>
                <span>£{{ subtotal.toFixed(2) }}</span>
              </div>

              <div class="summary-row">
                <span>Postage &amp; Packaging</span>
                <span>£{{ postageAndPackaging.toFixed(2) }}</span>
              </div>

              <div class="summary-row total-row">
                <span>Total</span>
                <span class="total-amount">£{{ grandTotal.toFixed(2) }}</span>
              </div>
            </div>

            <!-- Configuration Options -->
            <div class="config-section">
              <h3 class="config-title">Configuration</h3>
              
              <select v-model="newOrderConfig.businessType" class="config-select">
                <option value="">Select your business type</option>
                <option value="salon">Salon</option>
                <option value="hotel">Hotel</option>
                <option value="restaurant">Restaurant</option>
                <option value="pub">Pub</option>
                <option value="other">Other</option>
              </select>

              <select v-model="newOrderConfig.recipientType" class="config-select">
                <option value="">Select description for recipients</option>
                <option value="stylist">Stylist</option>
                <option value="therapist">Therapist</option>
                <option value="technician">Technician</option>
                <option value="nailtechnician">Nail Technician (out of stock)</option>
                <option value="nailtech">Nail Tech</option>
                <option value="nailstylist">Nail Stylist</option>
                <option value="artist">Artist</option>
                <option value="host">Host</option>
                <option value="waiter">Waiter</option>
                <option value="barstaff">Bar Staff</option>
                <option value="driver">Driver</option>
                <option value="team">Team</option>
                <option value="guide">Guide</option>
                <option value="trainer">Trainer</option>
                <option value="non-specific">Non-specific</option>
              </select>

              <textarea 
                v-model="newOrderConfig.notes" 
                class="config-textarea"
                placeholder="Additional notes or special requirements"
              ></textarea>
            </div>

            <!-- Contact Information -->
            <div class="contact-section">
              <h3 class="config-title">Contact & Delivery Information</h3>
              
              <input 
                v-model="newOrderConfig.name"
                type="text" 
                class="config-input"
                placeholder="Your name"
              />

              <input 
                v-model="newOrderConfig.businessName"
                type="text" 
                class="config-input"
                placeholder="Business name"
              />

              <input
                v-model="newOrderConfig.addressLine1"
                type="text"
                class="config-input"
                autocomplete="address-line1"
                placeholder="Address line 1"
              />
              <input
                v-model="newOrderConfig.addressLine2"
                type="text"
                class="config-input"
                autocomplete="address-line2"
                placeholder="Address line 2 (optional)"
              />
              <input
                v-model="newOrderConfig.addressCity"
                type="text"
                class="config-input"
                autocomplete="address-level2"
                placeholder="City"
              />
              <input
                v-model="newOrderConfig.addressPostcode"
                type="text"
                class="config-input"
                autocomplete="postal-code"
                placeholder="Postcode"
              />

              <input 
                v-model="newOrderConfig.email"
                type="email" 
                class="config-input"
                placeholder="Email address"
              />

              <input 
                v-model="newOrderConfig.phone"
                type="tel" 
                class="config-input"
                placeholder="Phone number (optional)"
              />

          <!-- REVIEW STEP (must be before Stripe UI) -->
          <div v-show="showOrderReview === true" class="order-summary" style="margin-top: 16px;" ref="orderReviewWrap">
            <div ref="reviewSectionAnchor" id="review-section-anchor"></div>
            <div class="summary-row total-row" style="font-weight: 700;">
              <span>Review your order</span>
              <span>£{{ grandTotal.toFixed(2) }}</span>
            </div>

            <div class="summary-row">
              <span>Front Desk Stands</span>
              <span>{{ orderItems.frontDesk.quantity }}</span>
            </div>
            <div class="summary-row">
              <span>Mirror Stickers</span>
              <span>{{ orderItems.mirrorStickers.quantity }}</span>
            </div>
            <div class="summary-row">
              <span>Tabletop Stands</span>
              <span>{{ orderItems.tabletopStands.quantity }}</span>
            </div>

            <div class="summary-row">
              <span>Subtotal</span>
              <span>£{{ subtotal.toFixed(2) }}</span>
            </div>
            <div class="summary-row">
              <span>Postage &amp; Packaging</span>
              <span>£{{ postageAndPackaging.toFixed(2) }}</span>
            </div>

            <div class="summary-row total-row">
              <span>Total</span>
              <span class="total-amount">£{{ grandTotal.toFixed(2) }}</span>
            </div>

            <div style="margin-top: 14px;">
              <div style="margin-top: 10px;">
                <a href="#" @click.prevent="doBackToEditOrder">← Edit order</a>
              </div>

              <div class="tufont" style="margin-top: 10px; opacity: 0.8;">
                Next step: payment
              </div>
            </div>
          </div>

          <!-- Anchor for scroll -->
          <div ref="paymentSectionAnchor" id="payment-section-anchor"></div>
          <!-- Payment Information (only for paid orders) -->
          <div class="config-section" v-if="useNewOrderForm" v-show="totalItems > 0 && showOrderReview === true && showPaymentStep === true" style="position: relative;">
            <h3 class="config-title">Payment Information</h3>

            <!-- Premium processing overlay (covers only the payment section) -->
            <div v-show="isPaying === true" class="tu-paying-overlay" aria-live="polite">
              <div class="tu-paying-card">
                <div class="tu-paying-top">
                  <span class="tu-spinner" aria-hidden="true"></span>
                  <div class="tu-paying-text">
                    <div class="tu-paying-title">Processing payment…</div>
                    <div class="tu-paying-sub">
                      Please don’t refresh this page.
                    </div>
                  </div>
                </div>

                
              </div>
            </div>

            <div v-show="showPaymentStep === true" style="margin-top: 6px; margin-bottom: 10px;">
            <a href="#" @click.prevent="doBackToReviewFromPayment">← Back to review</a>
          </div>
            
            <!-- Apple Pay / Google Pay Button -->
            <div v-show="showPaymentRequestButton" style="margin-bottom: 16px;">
              <div id="payment-request-button"></div>
              <div style="text-align: center; margin: 12px 0; color: #6b7280; font-size: 14px;">
                — or pay with card —
              </div>
            </div>
            
            <!-- Regular Card Input -->
            <div id="card-element" class="config-input" style="padding: 14px;"></div>
            
            <p class="privacy-note" style="text-align: left; margin-top: 8px;">
              Your payment is securely processed by Stripe. We never see or store your card details.
            </p>
          </div>
          
          <p class="privacy-note">
            Your email and phone are <strong>never</strong> shared with anyone
          </p>
            </div>

            <!-- Submit Button -->
            <button
              class="submit-order-btn"
              :disabled="!canSubmitNewOrder || isPaying === true"
              @click="doMainOrderButton()"
            >
              {{
                showOrderReview !== true
                  ? `Review Order - £${grandTotal.toFixed(2)}`
                  : (showPaymentStep !== true
                      ? 'Confirm & Continue to Payment'
                      : `Pay - £${grandTotal.toFixed(2)}`
                    )
              }}
            </button>

            <!-- Premium processing indicator -->
            <div
              v-show="isPaying === true"
              class="tu-processing"
            >
              <span class="tu-spinner" aria-hidden="true"></span>
              <span>Processing payment…</span>
            </div>

            <p class="contact-help">
              <strong>Questions?</strong> Call +442078560378 or email 
              <a href="mailto:mailorders@thanku.app">mailorders@thanku.app</a>
            </p>
          </div>
        </div>

        <!-- IMAGE LIGHTBOX -->
        <transition name="fade">
          <div v-show="showImageLightbox" class="image-lightbox-overlay" @click="closeLightbox">
            <div class="image-lightbox-content" @click.stop>
              <button class="lightbox-close-btn" @click="closeLightbox">×</button>
              <img :src="lightboxImageSrc" alt="Product Image" class="lightbox-image">
            </div>
          </div>
        </transition>

        <div
          v-show="this.useNewOrderForm === false && this.showOrderCompleted === true"
          class="col-md-8 offset-md-2 tugreybluebox"
          style="margin-top: 3vw"
        >
          <div class="tufont tumediumtitlebold" style="padding-bottom: 2vw">
            Thank you for your order
          </div>

          <div ref="orderDiv">
            <OrderItem
              title="Package ordered"
              :orderItem="this.orderedPackage"
            />
            <OrderItem
              title="Business type"
              :orderItem="this.orderedBusinessType"
            />
            <OrderItem
              title="Description of main recipient"
              :orderItem="this.orderedDescriptionRecipient"
            />
            <OrderItem
              v-show="this.showStickers === true"
              title='Number of "No Glue" Mirror Stickers'
              :orderItem="this.orderedNumberOfStickers"
            />
            <OrderItem
              v-show="this.showTableTop === true"
              title="Number of Tabletop Stands"
              :orderItem="this.orderedNumberOfTabletopStands"
            />
            <OrderItem title="Order notes" :orderItem="this.orderedNotes" />
            <OrderItem title="Your name" :orderItem="this.orderedName" />
            <OrderItem
              title="Business name"
              :orderItem="this.orderedBusinessName"
            />
            <OrderItem
              title="Address to send media"
              :orderItem="[this.orderedAddressLine1, this.orderedAddressLine2, this.orderedAddressCity, this.orderedAddressPostcode].filter(Boolean).join(', ')"
            />
            <OrderItem title="Email" :orderItem="this.orderedEmail" />
            <OrderItem title="Phone" :orderItem="this.orderedPhoneNumber" />
          </div>

          <table style="width: 100%; margin-top: 2vw">
            <tr>
              <td style="display: flex">
                <div
                  class="lt-blue notes-text"
                  style="width: 60%; padding-top: 0vw; line-height: 1px"
                >
                  <b>Any questions?</b> Please call us on +442078560378 or email
                  us at
                  <a
                    href="mailto:mailorders@thanku.app?subject=get ThankU enquiry&body=Please let us know your query or requirements: %0D%0A%0D%0A%0D%0AThank you! best wishes, the ThankU Team"
                    >mailorders@thanku.app</a
                  >
                </div>
                <br />
              </td>
            </tr>
          </table>
        </div>
        <!-- NEW ORDER COMPLETED (PROFESSIONAL) -->
        <div v-show="this.useNewOrderForm === true && this.showOrderCompleted === true" class="order-complete-wrap" ref="orderCompleteWrap">

          <div class="order-complete-card">
            <div class="order-complete-title">✅ Order confirmed</div>

            <div class="order-complete-sub">
              Thank you — we’ve received your media order.
            </div>

            <div class="order-complete-ref">
              <span class="order-complete-ref-label">Order number</span>
              <span class="order-complete-ref-value">{{ mediaOrderObjectId || '—' }}</span>
            </div>

            <div class="order-summary" style="margin-top: 14px;">
              <div class="summary-row">
                <span>Front Desk Stands</span>
                <span>{{ orderItems.frontDesk.quantity }}</span>
              </div>

              <div class="summary-row">
                <span>Mirror Stickers</span>
                <span>{{ orderItems.mirrorStickers.quantity }}</span>
              </div>

              <div class="summary-row">
                <span>Tabletop Stands</span>
                <span>{{ orderItems.tabletopStands.quantity }}</span>
              </div>

              <div class="summary-row" style="margin-top: 10px;">
                <span>Subtotal</span>
                <span>£{{ subtotal.toFixed(2) }}</span>
              </div>

              <div class="summary-row">
                <span>Postage &amp; Packaging</span>
                <span>£{{ postageAndPackaging.toFixed(2) }}</span>
              </div>

              <div class="summary-row total-row">
                <span>Total</span>
                <span class="total-amount">£{{ grandTotal.toFixed(2) }}</span>
              </div>
            </div>

            <div class="order-complete-sub" style="margin-top: 14px;">
              We’ll email a confirmation shortly. If you need to contact us, please quote your order number.
            </div>

            <div style="margin-top: 18px;">
              <button class="submit-order-btn" type="button" @click="doShowHome()" :disabled="isPaying === true">
                Back to Home
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>
    <br />
      <HomeFooter
        @do-show-contact="doShowContactNew"
        @do-show-about="doShowAboutNew"
        @do-show-privacy="doShowPrivacyNew"
        @do-show-terms="doShowTermsNew"
      />
  </div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js/pure';
const Parse = require("parse/node");
import shared from "../shared.js";
import LogRocket from "logrocket";

import { defineAsyncComponent } from "vue";

const NavigationBar = defineAsyncComponent({
  loader: () => import("../components/NavigationBar.vue"),
});

const HomePageTickedListItem = defineAsyncComponent({
  loader: () => import("../components/HomePageTickedListItem.vue"),
});

const OrderItem = defineAsyncComponent({
  loader: () => import("../components/OrderItem.vue"),
});

const HomeFooter = defineAsyncComponent({
  loader: () => import("../components/HomeFooter.vue"),
});

export default {
  inject: ["globalPushForwardInterval", "devEnv", "appId", "appJSKey"],
  data() {
    return {
      showPopUpOk: false,
      popUpMsgTitle: "",
      popUpMsgBody: "",
      fontSizeTitle: 2.7, // vh
      fontSizeTitleLineHeight: 5, //vh
      fontSizePopUpMsg: 2.3, // vh
      fontSizePopUpMsgLineHeight: 3.4, // vh

      fontSizeNormal: 3.0, // vh
      fontSizeNormalInPXToUse: "",
      fontSizeNormalLineHeight: 4.0, // vh
      fontSizeNormalInPXLineHeightToUse: "",
      nhbfmembers: false,
      // OLD FORM
      showStickers: true,
      showTableTop: false,
      showOrderForm: true,
      showOrderCompleted: false,
      orderedPackage: "",
      orderedBusinessType: "",
      orderedDescriptionRecipient: "",
      orderedNumberOfStickers: "",
      orderedNumberOfTabletopStands: "",
      orderedNotes: "",
      orderedName: "",
      orderedBusinessName: "",
      orderedAddressLine1: "",
      orderedAddressLine2: "",
      orderedAddressCity: "",
      orderedAddressPostcode: "",
      orderedEmail: "",
      orderedPhoneNumber: "",
      
      // NEW FORM
      useNewOrderForm: false,
      orderItems: {
        frontDesk: { quantity: 0, price: 3.00 },
        mirrorStickers: { quantity: 0, price: 1.00 },
        tabletopStands: { quantity: 0, price: 4.00 }
      },
      newOrderConfig: {
        businessType: '',
        recipientType: '',
        notes: '',
        name: '',
        businessName: '',
        addressLine1: '',
        addressLine2: '',
        addressCity: '',
        addressPostcode: '',
        email: '',
        phone: ''
      },
      showImageLightbox: false,
      lightboxImageSrc: '',
      stripePublishableKey: process.env.VUE_APP_STRIPE_ENV === "dev" ? process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_TEST : process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_LIVE,
      
      // STRIPE OBJECTS
      stripe: null,
      cardElement: null,
      showPaymentRequestButton: false,
      showOrderReview: false,
      showPaymentStep: false,

      mediaOrderObjectId: null,
      lastPaymentIntentId: null,
      hasBoundWalletHandler: false,
      isPaying: false,
      paymentMethodInProgress: null, // "wallet" | "card" | null
      hasMountedWalletButton: false,
      paymentRequest: undefined,
      prButton: null,
      elements: null,
    };
  },
  components: {
    NavigationBar,
    HomePageTickedListItem,
    HomeFooter,
    OrderItem,
  },
  computed: {
    frontdeskfull() {
      return require("@/assets/frontdeskfull.jpg");
    },
    stickerfull() {
      return require("@/assets/stickerfull.jpg");
    },
    countersquarefull() {
      return require("@/assets/countersquare.webp");
    },
    totalItems() {
      return this.orderItems.frontDesk.quantity + 
             this.orderItems.mirrorStickers.quantity + 
             this.orderItems.tabletopStands.quantity;
    },
    subtotal() {
      return (this.orderItems.frontDesk.quantity * this.orderItems.frontDesk.price) +
             (this.orderItems.mirrorStickers.quantity * this.orderItems.mirrorStickers.price) +
             (this.orderItems.tabletopStands.quantity * this.orderItems.tabletopStands.price);
    },
    canSubmitNewOrder() {
      return this.totalItems > 0 &&
             this.newOrderConfig.name &&
             this.newOrderConfig.businessName &&
             this.newOrderConfig.addressLine1 &&
             this.newOrderConfig.addressCity &&
             this.newOrderConfig.addressPostcode &&
             this.newOrderConfig.email &&
             this.newOrderConfig.businessType &&
             this.newOrderConfig.recipientType;
    },
    postageAndPackaging() {
        // Only charge postage when there is at least 1 item
        return this.totalItems > 0 ? 4.99 : 0;
    },

    grandTotal() {
        return this.subtotal + this.postageAndPackaging;
    },
  },
  methods: {
    getBusinessTypeLabelNew() {
        const map = {
            salon: "Salon",
            hotel: "Hotel",
            restaurant: "Restaurant",
            pub: "Pub",
            other: "Other",
        };
        return map[this.newOrderConfig.businessType] || (this.newOrderConfig.businessType || "");
    },

    getRecipientTypeLabelNew() {
        const map = {
            stylist: "Stylist",
            therapist: "Therapist",
            technician: "Technician",
            nailtechnician: "Nail Technician (out of stock)",
            nailtech: "Nail Tech",
            nailstylist: "Nail Stylist",
            artist: "Artist",
        };
        return map[this.newOrderConfig.recipientType] || (this.newOrderConfig.recipientType || "");
    },
    updateWalletTotalIfAny() {
        try {
            if (this.paymentRequest) {
                this.paymentRequest.update({
                    total: {
                        label: "ThankU Media Order",
                        amount: Math.round(this.grandTotal * 100),
                    },
                });
            }
        } catch (e) {
            // ignore
        }
    },
    sendMediaOrderEmailsFrontend(mailHTML, internalHTML, toEmail, orderName) {

        const params = {
            toEmail: toEmail,
            subject: "We have received your order for ThankU Cashless Tipping QR media",
            body: mailHTML,
            orderName: orderName,
            sgTemplateName: "sendMediaOrderedEmail2024",
        };

        Parse.Cloud.run("sendEmail", params);

        const params2 = {
            toEmail: "appalert@thanku.app",
            subject: "ThankU ORDER RECEIVED",
            body: internalHTML,
        };

        Parse.Cloud.run("sendEmail", params2);
    },
      scrollToRefBelowNavbar(refName, extraPaddingPx = 8) {
      this.$nextTick(() => {
          const el = this.$refs[refName];
          if (!el) {
              return;
          }

          // Try to find the fixed navbar (Bootstrap uses .navbar.fixed-top)
          const nav = document.querySelector(".navbar.fixed-top");
          const navH = nav ? nav.getBoundingClientRect().height : 0;

          // Element's Y position in document coords
          const elTop = el.getBoundingClientRect().top + window.pageYOffset;

          const targetY = Math.max(0, elTop - navH - extraPaddingPx);

          window.scrollTo({
              top: targetY,
              left: 0,
              behavior: "smooth",
          });
      });
    },
    attachBlurZoomReset() {
      this.$nextTick(() => {
        const inputs = document.querySelectorAll('input, textarea'); // excludes select: blur+blur trick dismisses native pickers on iOS
        inputs.forEach(input => {
          input.removeEventListener('blur', this.resetZoomAfterBlur); // remove first
          input.addEventListener('blur', this.resetZoomAfterBlur);
        });
      });
    },
    resetZoomAfterBlur() {
      window.setTimeout(() => {
        const el = document.activeElement;
        if (el) el.blur(); // ensure focus is fully released

        // Force Safari to reset zoom by temporarily manipulating the viewport meta
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          const original = viewport.getAttribute('content');
          viewport.setAttribute('content', original + ', maximum-scale=1');
          window.setTimeout(() => {
            viewport.setAttribute('content', original);
          }, 50);
        }
      }, 100);
    },
    validateMediaOrderAndGetPopup(orderMode) {
        // orderMode: "old" uses $refs, "new" uses this.newOrderConfig + items
        // Returns: null if OK, else { title, body }

        if (orderMode === "new") {
            if (this.totalItems <= 0) {
                return {
                    title: "Info required",
                    body: "Please add at least one item to your order"
                };
            }

            if (!this.newOrderConfig.name) {
                return {
                    title: "Info required",
                    body: "Please provide your name so we can contact you, if necessary, about your order"
                };
            }

            if (!this.newOrderConfig.businessName) {
                return {
                    title: "Info required",
                    body: "Please provide your business name - normally the name of your brand as it will be shown on thankU"
                };
            }

            if (!this.newOrderConfig.addressLine1 || !this.newOrderConfig.addressCity || !this.newOrderConfig.addressPostcode) {
                return {
                    title: "Info required",
                    body: "Please provide your full delivery address including city and postcode"
                };
            }

            if (!this.newOrderConfig.email) {
                return {
                    title: "Info required",
                    body: "Please provide your email so that we can update you on your order"
                };
            }

            if (shared.validEmail(this.newOrderConfig.email) === false) {
                return {
                    title: "Sorry",
                    body: this.newOrderConfig.email + " is not a valid email address"
                };
            }

            if (!this.newOrderConfig.businessType) {
                return {
                    title: "Info required",
                    body: "Please select the type of business"
                };
            }

            if (!this.newOrderConfig.recipientType) {
                return {
                    title: "Info required",
                    body: "Please select the description of the main recipient"
                };
            }

            return null;
        }

        // ----- OLD FLOW (refs) -----

        if (this.$refs.orderName.value === "") {
            return {
                title: "Info required",
                body: "Please provide your name so we can contact you, if necessary, about your order"
            };
        }

        if (this.$refs.orderBusinessName.value === "") {
            return {
                title: "Info required",
                body: "Please provide your business name - normally the name of your brand as it will be shown on thankU"
            };
        }

        if (this.$refs.orderAddressLine1.value === "" || this.$refs.orderAddressCity.value === "" || this.$refs.orderAddressPostcode.value === "") {
            return {
                title: "Info required",
                body: "Please provide your full delivery address including city and postcode"
            };
        }

        if (this.$refs.orderEmail.value === "") {
            return {
                title: "Info required",
                body: "Please provide your email so that we can update you on your order"
            };
        }

        if (shared.validEmail(this.$refs.orderEmail.value) === false) {
            return {
                title: "Sorry",
                body: this.$refs.orderEmail.value + " is not a valid email address"
            };
        }

        return null;
    },
    buildMediaOrderEmailHTML(payload) {

        let mailHTML =
            '<table border=0 style="padding-top: 4px; padding-bottom: 4px">';

        // Order number row (ONLY if we actually have one)
        if (payload.orderNumber && payload.orderNumber !== "—") {
            mailHTML +=
                '<tr>' +
                    '<td style="width: 40%">Order number:</td>' +
                    '<td style="width: 60%">' + payload.orderNumber + '</td>' +
                '</tr>';
        }

        // NOTE: Intentionally NOT showing "Package ordered" in the email.

        mailHTML +=
            '<tr>' +
                '<td style="width: 40%">Business type:</td>' +
                '<td style="width: 60%">' + (payload.businessType || "") + '</td>' +
            '</tr>' +

            '<tr>' +
                '<td>Description of main recipient:</td>' +
                '<td>' + (payload.descriptionRecipient || "") + '</td>' +
            '</tr>';

        if (payload.showStickers === true) {
            mailHTML +=
                '<tr>' +
                    '<td>Number of "No Glue" Mirror Stickers:</td>' +
                    '<td>' + (payload.numberOfStickers || "") + '</td>' +
                '</tr>';
        }

        if (payload.showTableTop === true) {
            mailHTML +=
                '<tr>' +
                    '<td>Number of Tabletop Stands:</td>' +
                    '<td>' + (payload.numberOfTabletopStands || "") + '</td>' +
                '</tr>';
        }

        mailHTML +=
            '<tr>' +
                '<td>Order notes:</td>' +
                '<td>' + (payload.notes || "") + '</td>' +
            '</tr>' +

            '<tr>' +
                '<td>Your name:</td>' +
                '<td>' + (payload.name || "") + '</td>' +
            '</tr>' +

            '<tr>' +
                '<td>Business name:</td>' +
                '<td>' + (payload.businessName || "") + '</td>' +
            '</tr>' +

            '<tr>' +
                '<td>Address to send media:</td>' +
                '<td>' + (payload.address || "") + '</td>' +
            '</tr>' +

            '<tr>' +
                '<td>Email:</td>' +
                '<td>' + (payload.email || "") + '</td>' +
            '</tr>' +

            '<tr>' +
                '<td>Phone:</td>' +
                '<td>' + (payload.phone || "") + '</td>' +
            '</tr>' +

            '</table>';

        return mailHTML;
    },
    doBackToReviewFromPayment() {
        this.showPaymentStep = false;

        this.scrollToRefBelowNavbar("reviewSectionAnchor", 8);
    },
    doDetectSelectChangeBusinessType() {
    // Legacy handler referenced by template — keep as no-op or add logic
    },

    doDetectSelectChangeDescriptionRecipient() {
        // Legacy handler referenced by template — keep as no-op or add logic
    },

    doDetectSelectChangeNumberOfStickers() {
        // Legacy handler referenced by template — keep as no-op or add logic
    },
    async tryInitStripeOnce() {
        // Only init Stripe when:
        // - we are in the paid form
        // - user has items
        // - user has confirmed and is on payment step
        // - card element not already created
        if (this.useNewOrderForm === true &&
            this.totalItems > 0 &&
            this.showOrderReview === true &&
            this.showPaymentStep === true 
        ) {
            await this.initializeStripeCardElement();
        }
    },
    doMainOrderButton() {
        // Step 1: go to review
        if (this.showOrderReview !== true) {
            this.doGoToOrderReview();
            return;
        }

        // Step 2: user confirmed review -> show payment UI
        if (this.showPaymentStep !== true) {
            this.doConfirmAndShowPayment();
            return;
        }

        // Step 3: payment step is visible -> card payment submit
        // Wallet users will use Apple/Google Pay buttons; card users use this.
        this.submitNewPaidOrder();
    },
    doGoToOrderReview() {
        const popup = this.validateMediaOrderAndGetPopup("new");
        if (popup) {
            this.popUpMsgTitle = popup.title;
            this.popUpMsgBody = popup.body;
            this.showPopUpOk = true;
            return;
        }

        this.showOrderReview = true;
        this.showPaymentStep = false;

        this.scrollToRefBelowNavbar("reviewSectionAnchor", 8);
    },

    doBackToEditOrder() {
        this.showOrderReview = false;
        this.showPaymentStep = false;
    },

    doConfirmAndShowPayment() {
        this.showPaymentStep = true;
        this.$nextTick(() => {
            this.updateWalletTotalIfAny();
        });
        this.scrollToRefBelowNavbar("paymentSectionAnchor", 8);
    },
    doToggleToPaidForm() {
      console.log("=== doToggleToPaidForm triggered ===");

      this.$router.replace({
        query: {
          ...this.$route.query,
          donew: 'true'
        }
      });

      this.useNewOrderForm = true;
    },
    async initializeStripeCardElement() {
        await this._loadStripeLibraryOnce();

        // Create Stripe instance ONCE and store it
        if (!this.stripe) {
            this.stripe = window.Stripe(this.stripePublishableKey);
        }

        const elements = this.elements || (this.elements = this.stripe.elements());

        // IMPORTANT: Only mount Stripe elements if the mount points exist in the DOM
        await this.$nextTick();

        const prMountEl = document.querySelector("#payment-request-button");
        const cardMountEl = document.querySelector("#card-element");

        // If the payment UI isn't currently rendered, do not attempt to mount anything
        if (!prMountEl && !cardMountEl) {
            console.log("Stripe init skipped: no mount elements in DOM yet");
            return;
        }

        // Create / reuse Payment Request for Apple Pay / Google Pay (ONLY if mount point exists)
        if (prMountEl) {

            // ✅ Reuse existing paymentRequest if we already created it (prevents stale total)
            if (!this.paymentRequest) {
                this.paymentRequest = this.stripe.paymentRequest({
                    country: "GB",
                    currency: "gbp",
                    total: {
                        label: "ThankU Media Order",
                        amount: Math.round(this.grandTotal * 100),
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,
                });
            } else {
                // keep it fresh
                this.updateWalletTotalIfAny();
            }

            const paymentRequest = this.paymentRequest;

            // ✅ Create PR button once (prevents duplicate mounts)
            if (!this.prButton) {
                this.prButton = elements.create("paymentRequestButton", {
                    paymentRequest: paymentRequest,
                });
            }

            // (Optional but safe) If Stripe ever needs the PR object refreshed on the element:
            // try { this.prButton.update({ paymentRequest }); } catch (e) {}

            paymentRequest
                .canMakePayment()
                .then((result) => {
                    console.log("Payment Request availability:", result);
                    if (result) {
                        const prMountEl2 = document.querySelector("#payment-request-button");
                        if (prMountEl2) {

                            if (this.hasMountedWalletButton !== true) {
                                console.log(
                                    "Mounting payment request button for:",
                                    result.applePay ? "Apple Pay" : "Google Pay"
                                );
                                try {
                                    this.prButton.mount("#payment-request-button");
                                    this.hasMountedWalletButton = true;
                                } catch (e) {
                                    // ignore "already mounted" type errors
                                }
                            }

                            this.showPaymentRequestButton = true;
                        } else {
                            console.log("Skipped mounting payment request button: mount element not in DOM");
                            this.showPaymentRequestButton = false;
                        }
                    } else {
                        this.showPaymentRequestButton = false;
                    }
                })
                .catch((error) => {
                    console.error("Error checking payment method availability:", error);
                    this.showPaymentRequestButton = false;
                });

            // Handle the payment when user clicks Apple Pay / Google Pay
            if (this.hasBoundWalletHandler !== true) {
                paymentRequest.on("paymentmethod", async (ev) => {
                    try {
                        if (this.isPaying === true) {
                            try { ev.complete("fail"); } catch (e) {}
                            return;
                        }

                        this.isPaying = true;
                        this.paymentMethodInProgress = "wallet";

                        const mediaOrderReturnJSON = await Parse.Cloud.run(
                            "createPaymentIntentForMediaOrder",
                            this.returnStripeJSON()
                        );

                        this.mediaOrderObjectId = mediaOrderReturnJSON.mediaOrderObjectId || null;

                        const { error: confirmError } = await this.stripe.confirmCardPayment(
                            mediaOrderReturnJSON.clientSecret,
                            { payment_method: ev.paymentMethod.id }
                        );

                        if (confirmError) {
                            this.isPaying = false;
                            this.paymentMethodInProgress = null;
                            ev.complete("fail");
                            this.popUpMsgTitle = "Payment Failed";
                            this.popUpMsgBody = confirmError.message;
                            this.showPopUpOk = true;
                        } else {
                            ev.complete("success");

                            // Finalise server-side (source of truth)
                            try {
                                const payload = {
                                    businessType: this.getBusinessTypeLabelNew(),
                                    descriptionRecipient: this.getRecipientTypeLabelNew(),

                                    showStickers: (this.orderItems.mirrorStickers.quantity > 0),
                                    numberOfStickers: String(this.orderItems.mirrorStickers.quantity),

                                    showTableTop: (this.orderItems.tabletopStands.quantity > 0),
                                    numberOfTabletopStands: String(this.orderItems.tabletopStands.quantity),

                                    notes: this.newOrderConfig.notes || "",
                                    name: this.newOrderConfig.name,
                                    businessName: this.newOrderConfig.businessName,
                                    address: [this.newOrderConfig.addressLine1, this.newOrderConfig.addressLine2, this.newOrderConfig.addressCity, this.newOrderConfig.addressPostcode].filter(Boolean).join(', '),
                                    email: this.newOrderConfig.email,
                                    phone: this.newOrderConfig.phone || ""
                                };

                                const fin = await Parse.Cloud.run("finaliseMediaOrderPaymentIntent", {
                                    paymentIntentId: mediaOrderReturnJSON.strPaymentIntentId,
                                });

                                if (fin && fin.mediaOrderObjectId) {
                                    this.mediaOrderObjectId = fin.mediaOrderObjectId;
                                }

                                const mailHTML =
                                  this.buildMediaOrderEmailHTML({
                                    ...payload,
                                    orderNumber: this.mediaOrderObjectId
                                  });

                                const internalHTML =
                                    "<h3>PAID MEDIA ORDER (WALLET)</h3>" +
                                    "<p><b>mediaOrderObjectId:</b> " + (this.mediaOrderObjectId || "—") + "</p>" +
                                    "<p><b>paymentIntentId:</b> " + (mediaOrderReturnJSON.strPaymentIntentId || "—") + "</p>" +
                                    "<hr/>" +
                                    mailHTML;

                                this.sendMediaOrderEmailsFrontend(
                                    mailHTML,
                                    internalHTML,
                                    this.newOrderConfig.email,
                                    this.newOrderConfig.name
                                );

                            } catch (eFin) {
                                console.error("Finalise failed (wallet):", eFin);
                                this.isPaying = false;
                                this.paymentMethodInProgress = null;

                                this.popUpMsgTitle = "Order Processing Error";
                                this.popUpMsgBody =
                                    "Your payment may have gone through, but we couldn't finalise your order. Please contact support at payments@thanku.app with this reference " +
                                    this.mediaOrderObjectId;
                                this.showPopUpOk = true;
                                return;
                            }

                            this.isPaying = false;
                            this.paymentMethodInProgress = null;
                            this.showOrderConfirmationScreen();
                        }
                    } catch (error) {
                        this.isPaying = false;
                        this.paymentMethodInProgress = null;
                        ev.complete("fail");
                        console.error("Payment error:", error);
                        this.popUpMsgTitle = "Payment Error";
                        this.popUpMsgBody = "There was an error processing your payment. Please try again.";
                        this.showPopUpOk = true;
                    }
                });

                this.hasBoundWalletHandler = true;
            }

        } else {
            this.showPaymentRequestButton = false;
        }

        // Create regular card element
        if (!this.cardElement) {
            this.cardElement = elements.create("card", {
                hidePostalCode: true,
                style: {
                    base: {
                        fontSize: "16px",
                        color: "#1a1a1a",
                        "::placeholder": {
                            color: "#9ca3af",
                        },
                    },
                },
            });
        }

        const cardMountEl2 = document.querySelector("#card-element");
        if (!cardMountEl2) {
            console.log("Stripe card mount skipped: #card-element not in DOM yet");
            return;
        }

        try {
            this.cardElement.mount("#card-element");
        } catch (e) {
            // ignore "already mounted" type errors
        }
    },
    _loadStripeLibraryOnce() {
        var self = this;
        return new Promise(function(resolve, reject) {
          try {
            if (typeof window !== "undefined" && window.Stripe && typeof window.Stripe === "function") {
              resolve({ loadedAt: new Date().toISOString(), version: self._detectStripeVersion() });
              console.log("Stripe successfully loaded")
              return;
            }
          } catch (e) {}
          try {
            if (typeof window !== "undefined" && window.__stripeSdkLoadingPromise) {
              window.__stripeSdkLoadingPromise.then(resolve).catch(reject);
              return;
            }
          } catch (e) {}

          var p = new Promise(function(res, rej) {
            try {
              var existing = document.getElementById("stripe-js");
              if (!existing) {
                var s = document.createElement("script");
                s.id = "stripe-js";
                s.src = "https://js.stripe.com/v3/";
                s.async = true;
                s.onload = function() {
                  try { res({ loadedAt: new Date().toISOString(), version: self._detectStripeVersion() }); }
                  catch (e2) { res({ loadedAt: new Date().toISOString(), version: "n/a" }); }
                };
                s.onerror = function() { rej(new Error("Stripe script onerror")); };
                document.head.appendChild(s);
              } else {
                window.setTimeout(function() {
                  try {
                    if (window.Stripe) { res({ loadedAt: new Date().toISOString(), version: self._detectStripeVersion() }); }
                    else { rej(new Error("Stripe tag exists but window.Stripe is undefined")); }
                  } catch (e3) {
                    rej(new Error("Stripe tag exists but access threw"));
                  }
                }, 0);
              }
            } catch (e) { rej(e); }
          });

          try { window.__stripeSdkLoadingPromise = p; } catch (e) {}
          p.then(resolve).catch(reject);
        });
      },

    _detectStripeVersion() {
      try {
        if (window && window.Stripe && window.Stripe.toString) {
          var s = String(window.Stripe.toString());
          return s.indexOf("[native code]") !== -1 ? "v3-native" : "present";
        }
      } catch (e) {}
      return "n/a";
    },

    returnStripeJSON(){
      return {
          amount: Math.round(this.grandTotal * 100), // Convert to pence, ensure integer
          currency: 'gbp',
          customerEmail: this.newOrderConfig.email,
          customerName: this.newOrderConfig.name,
          orderDetails: {
            frontDesk: this.orderItems.frontDesk.quantity,
            mirrorStickers: this.orderItems.mirrorStickers.quantity,
            tabletopStands: this.orderItems.tabletopStands.quantity,
            businessType: this.newOrderConfig.businessType,
            recipientType: this.newOrderConfig.recipientType,
            notes: this.newOrderConfig.notes,
            businessName: this.newOrderConfig.businessName,
            address: [this.newOrderConfig.addressLine1, this.newOrderConfig.addressLine2, this.newOrderConfig.addressCity, this.newOrderConfig.addressPostcode].filter(Boolean).join(', '),
            phone: this.newOrderConfig.phone
          }
        }
    },

    async submitNewPaidOrder() {

      console.log("submitting NEW order")
      const popup = this.validateMediaOrderAndGetPopup("new");
      if (popup) {
          this.popUpMsgTitle = popup.title;
          this.popUpMsgBody = popup.body;
          this.showPopUpOk = true;
          return;
      }

      if (this.isPaying === true) {
          return;
      }

      this.isPaying = true;
      this.paymentMethodInProgress = "card";

      try {
      
        // *** FIX: Use this.stripe instead of creating a new instance ***
        
        // Create payment intent via Parse Cloud Function
        const mediaOrderReturnJSON = await Parse.Cloud.run("createPaymentIntentForMediaOrder", this.returnStripeJSON());

        console.log("mediaOrderReturnJSON: <pre>" + JSON.stringify(mediaOrderReturnJSON, null,4) + "</pre>");

        this.mediaOrderObjectId = mediaOrderReturnJSON.mediaOrderObjectId || null;
        this.lastPaymentIntentId = mediaOrderReturnJSON.strPaymentIntentId || null;
        
        // *** FIX: Use this.stripe that was created in initializeStripeCardElement ***
        const { error} = await this.stripe.confirmCardPayment(
          mediaOrderReturnJSON.clientSecret,
          {
            payment_method: {
              card: this.cardElement,
              billing_details: {
                name: this.newOrderConfig.name,
                email: this.newOrderConfig.email,
                address: {
                  line1: this.newOrderConfig.addressLine1,
                  line2: this.newOrderConfig.addressLine2 || undefined,
                  city: this.newOrderConfig.addressCity,
                  postal_code: this.newOrderConfig.addressPostcode
                }
              }
            }
          }
        );

        
        
        if (error) {
          // Payment failed
          this.popUpMsgTitle = "Payment Failed";
          this.popUpMsgBody = error.message;
          this.showPopUpOk = true;
          return;
        }
        
        // Payment successful!
        // Payment successful — finalise server-side (source of truth)
        
        const payload = {
            businessType: this.getBusinessTypeLabelNew(),
            descriptionRecipient: this.getRecipientTypeLabelNew(),

            // In the new flow, these "show" flags are based on qty > 0
            showStickers: (this.orderItems.mirrorStickers.quantity > 0),
            numberOfStickers: String(this.orderItems.mirrorStickers.quantity),

            showTableTop: (this.orderItems.tabletopStands.quantity > 0),
            numberOfTabletopStands: String(this.orderItems.tabletopStands.quantity),

            notes: this.newOrderConfig.notes || "",
            name: this.newOrderConfig.name,
            businessName: this.newOrderConfig.businessName,
            address: [this.newOrderConfig.addressLine1, this.newOrderConfig.addressLine2, this.newOrderConfig.addressCity, this.newOrderConfig.addressPostcode].filter(Boolean).join(', '),
            email: this.newOrderConfig.email,
            phone: this.newOrderConfig.phone || ""
        };

        

        try {
            const fin = await Parse.Cloud.run("finaliseMediaOrderPaymentIntent", {
                paymentIntentId: mediaOrderReturnJSON.strPaymentIntentId,
            });

            // If backend found and saved the row, we can trust the order id
            if (fin && fin.mediaOrderObjectId) {
                this.mediaOrderObjectId = fin.mediaOrderObjectId;
            }

            const mailHTML =
              this.buildMediaOrderEmailHTML({
                ...payload,
                orderNumber: this.mediaOrderObjectId
              });
            // ✅ send emails from FRONT END
            const internalHTML =
                "<h3>PAID MEDIA ORDER (CARD)</h3>" +
                "<p><b>mediaOrderObjectId:</b> " + (this.mediaOrderObjectId || "—") + "</p>" +
                "<p><b>paymentIntentId:</b> " + (mediaOrderReturnJSON.strPaymentIntentId || "—") + "</p>" +
                "<hr/>" +
                mailHTML;

            this.sendMediaOrderEmailsFrontend(
                mailHTML,
                internalHTML,
                this.newOrderConfig.email,
                this.newOrderConfig.name
            );

        } catch (eFin) {
            // Don't block UX, but this is important — your backend already emails appalert on failure
            console.error("Finalise failed:", eFin);
            this.popUpMsgTitle = "Order Processing Error";
            this.popUpMsgBody = "Your payment may have gone through, but we couldn't finalise your order. Please contact support at payments@thanku.app with this reference " + this.mediaOrderObjectId;
            this.showPopUpOk = true;
            return;
        }

        this.showOrderConfirmationScreen();
        
      } catch (error) {
        console.error("Payment error:", error);
        this.popUpMsgTitle = "Payment Error";
        this.popUpMsgBody = "There was an error processing your payment. Please try again.";
        this.showPopUpOk = true;
      } finally {
          this.isPaying = false;
          this.paymentMethodInProgress = null;
      }
    },

    showOrderConfirmationScreen() {
      this.showOrderForm = false;
      this.showOrderReview = false;
      this.showPaymentStep = false;
      this.showOrderCompleted = true;

      this.scrollToRefBelowNavbar("orderCompleteWrap", 8);
    },

    // NEW ORDER FORM METHODS
    openImageLightbox(imageSrc) {
      this.lightboxImageSrc = imageSrc;
      this.showImageLightbox = true;
    },
    closeLightbox() {
      this.showImageLightbox = false;
      this.lightboxImageSrc = '';
    },
    incrementItem(itemKey) {
      this.orderItems[itemKey].quantity++;
    },
    decrementItem(itemKey) {
      if (this.orderItems[itemKey].quantity > 0) {
        this.orderItems[itemKey].quantity--;
      }
    },
  

    // OLD METHODS
    doShowHome() {
      console.log("ok let's doShowHome NEW");
      let returnJSON = { showHomeNew: true, fromScreen: "getTipsStartNew" };
      this.$emit("return-json", returnJSON);
    },
    doShowAccount(){
      console.log("ok let's doShowAccount");
      let returnJSON = { showAccount: true, fromScreen: "getTipsStartNew"  };
      this.$emit('return-json', returnJSON);
    },
    doShowTipWithoutScanning(){
      let returnJSON = { showTipWithoutScanning: true, fromScreen: "getTipsStartNew" };
      this.$emit('return-json', returnJSON);
    },
    doGiveTipsShowMoreInfoNew() {
      console.log("show more info NEW! .. on doGiveTipsShowMoreInfoNew");
      let returnJSON = {
        showMoreGiveInfoNew: true,
        fromScreen: "getTipsStartNew",
      };
      this.$emit("return-json", returnJSON);
    },
    doGetTipsShowMoreInfoNew() {
      console.log("show more info NEW! .. on doGetTipsShowMoreInfoNew");
      let returnJSON = {
        showMoreGetInfoNew: true,
        fromScreen: "getTipsStartNew",
      };
      this.$emit("return-json", returnJSON);
    },
    doGetTipsShowMoreInfoFeesNew() {
      console.log("show more info plus fees NEW!");
      let returnJSON = {
        showMoreGetInfoNew: true,
        feesShow: true,
        fromScreen: "getTipsStartNew",
      };
      this.$emit("return-json", returnJSON);
    },
    doShowContactNew() {
      let returnJSON = { showContactNew: true, fromScreen: "getTipsStartNew" };
      this.$emit("return-json", returnJSON);
    },
    doPopUpOk() {
      this.showPopUpOk = false;
    },
    doDetectSelectChangePackage() {
      let orderPackage = this.$refs.changePackage.value;
      if (orderPackage === "regular") {
        this.showStickers = true;
        this.showTableTop = false;
      } else if (orderPackage === "discreet") {
        this.showStickers = false;
        this.showTableTop = true;
      } else {
        this.showStickers = true;
        this.showTableTop = true;
      }
    },
    doSubmitOrder() {
      console.log("submitting order");

      const popup = this.validateMediaOrderAndGetPopup("old");
      if (popup) {
          this.popUpMsgTitle = popup.title;
          this.popUpMsgBody = popup.body;
          this.showPopUpOk = true;
          return;
      }

      
        this.orderedPackage =
          this.$refs.changePackage.selectedIndex === 0
            ? this.$refs.changePackage.options[1].text
            : this.$refs.changePackage.options[
                this.$refs.changePackage.selectedIndex
              ].text;
        this.orderedBusinessType =
          this.$refs.changeBusinessType.selectedIndex === 0
            ? this.$refs.changeBusinessType.options[1].text
            : this.$refs.changeBusinessType.options[
                this.$refs.changeBusinessType.selectedIndex
              ].text;
        this.orderedDescriptionRecipient =
          this.$refs.changeDescriptionRecipient.selectedIndex === 0
            ? this.$refs.changeDescriptionRecipient.options[1].text
            : this.$refs.changeDescriptionRecipient.options[
                this.$refs.changeDescriptionRecipient.selectedIndex
              ].text;
        this.orderedNumberOfStickers =
          this.$refs.changeNumberOfStickers.value === "31"
            ? "more than 30"
            : this.$refs.changeNumberOfStickers.value;
        this.orderedNumberOfTabletopStands =
          this.$refs.changeNumberOfTabletopStands.value === "4"
            ? "more than 3"
            : this.$refs.changeNumberOfTabletopStands.value;
        this.orderedNotes = this.$refs.orderNotes.value;
        this.orderedName = this.$refs.orderName.value;
        this.orderedBusinessName = this.$refs.orderBusinessName.value;
        this.orderedAddressLine1 = this.$refs.orderAddressLine1.value;
        this.orderedAddressLine2 = this.$refs.orderAddressLine2.value;
        this.orderedAddressCity = this.$refs.orderAddressCity.value;
        this.orderedAddressPostcode = this.$refs.orderAddressPostcode.value;
        this.orderedEmail = this.$refs.orderEmail.value;
        this.orderedPhoneNumber = this.$refs.orderPhoneNumber.value;

        this.showOrderForm = false;
        this.showOrderCompleted = true;

        this.$nextTick(() => {
          const payload = {
              packageOrdered: this.orderedPackage,
              businessType: this.orderedBusinessType,
              descriptionRecipient: this.orderedDescriptionRecipient,

              showStickers: this.showStickers === true,
              numberOfStickers: this.orderedNumberOfStickers,

              showTableTop: this.showTableTop === true,
              numberOfTabletopStands: this.orderedNumberOfTabletopStands,

              notes: this.orderedNotes,
              name: this.orderedName,
              businessName: this.orderedBusinessName,
              address: [this.orderedAddressLine1, this.orderedAddressLine2, this.orderedAddressCity, this.orderedAddressPostcode].filter(Boolean).join(', '),
              email: this.orderedEmail,
              phone: this.orderedPhoneNumber
          };

          const mailHTML =
            this.buildMediaOrderEmailHTML({
              ...payload,
              orderNumber: this.mediaOrderObjectId 
            });

          const params = {
            toEmail: this.orderedEmail,
            subject:
              "We have received your order for ThankU Cashless Tipping QR media",
            body: mailHTML,
            orderName: this.orderedName,
            sgTemplateName: "sendMediaOrderedEmail2024",
          };

          Parse.Cloud.run("sendEmail", params);

          const params2 = {
            toEmail: "appalert@thanku.app",
            subject: "ThankU ORDER RECEIVED",
            body: this.$refs.orderDiv.outerHTML,
          };

          Parse.Cloud.run("sendEmail", params2);
        });
      
    },
    doFontSizeComputed() {
      this.fontSizeNormalInPXToUse = shared.convertVHSizeToMaxPixelsSize(
        this.fontSizeNormal,
        16
      );
      this.fontSizeNormalInPXLineHeightToUse =
        shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormalLineHeight, 20);
    },
    doOrderBadges() {
      console.log("TAKE MY ORDER!");
      this.scrollToRefBelowNavbar("orderForm", 8);
    },
    doShowGetTipsStartNew() {
      console.log("TAKE MY ORDER!");
      this.scrollToRefBelowNavbar("orderForm", 8);
    },
    doDownloadBrochure() {
      const url = "https://www.thanku.app/introtothanku.pdf";

      let LRObjectId = undefined;

      if (window.localStorage.getItem("tuob") !== null) {
        LRObjectId = window.localStorage.getItem("tuob");
      } else if (
        window.localStorage.getItem("logRocketUserTimeStampId") !== null
      ) {
        LRObjectId = window.localStorage.getItem("logRocketUserTimeStampId");
      } else {
        window.localStorage.setItem(
          "logRocketUserTimeStampId",
          new Date().getTime()
        );
        LRObjectId = window.localStorage.getItem("logRocketUserTimeStampId");
      }

      let googleAdsOriginalReferrerURL =
        window.localStorage.getItem("googleAdsOriginalReferrerURL") !==
        undefined
          ? window.localStorage.getItem("googleAdsOriginalReferrerURL")
          : "n/a";

      const params = {
        toEmail: "appalert@thanku.app",
        subject:
          "GREAT! Someone downloaded ThankU pdf brochure on NEW ORDER PAGE",
        body: {
          type: "TappedDownloadThankUBrochure",
          googleAdsOriginalReferrerURL: googleAdsOriginalReferrerURL,
          referrerURL: window.localStorage.getItem("referrerURL"),
          LRObjectId: LRObjectId,
        },
      };

      Parse.Cloud.run("sendEmail", params);

      window.open(url, "_self");
    },
    goBack() {
      if (window.localStorage.getItem("nextScreen") !== null && window.localStorage.getItem("nextScreen") !== undefined) {
        let returnJSON = {
          nextScreen: window.localStorage.getItem("nextScreen"),
        };
        this.$emit("return-json", returnJSON);
        window.localStorage.removeItem("nextScreen");
      } else {
        let returnJSON = { showHome: true, };
        this.$emit("return-json", returnJSON);
      }
    },
    doSetMetas() {
      const title = this.useNewOrderForm ? 
        "Order ThankU Cashless Tipping QR badges" : 
        "Get free ThankU Cashless Tipping QR badges";
      
      const description = this.useNewOrderForm ?
        "Order your ThankU Cashless Tipping QR badges - select from our range of stands and stickers, configure for your business, and complete your order online." :
        "Get free ThankU Cashless Tipping QR badges - our stand-mounted ThankU QR badges are just 6x4x2cm. They sit at the front desk and at your client seats (at your option). Simply tap the 'Order ThankU badges' button below, tell us which design/colour you like (1, 2, or 3), how many you need, and the address to send them to - that's it!";

      document.title = title;
      document
        .getElementsByTagName("meta")
        .namedItem("description")
        .setAttribute("content", description);
    },
    async deployLogRocket() {
      var LRObjectId = new Date().getTime();

      if (window.localStorage.getItem("tuob") !== null) {
        LRObjectId = window.localStorage.getItem("tuob");
      }

      if (LRObjectId === "4g278vWUb1" || LRObjectId === "2fBkimFcIw") {
        return;
      }

      var LRDisplayname = "LR Name not given";

      if (window.localStorage.getItem("tudis") !== null) {
        LRDisplayname = window.localStorage.getItem("tudis");
      }

      try {
        LogRocket.identify(LRObjectId, {
          name: LRDisplayname + ": get started",
          email: undefined,
        });
      } catch (e) {
        const params = {
          toEmail: "appalert@thanku.app",
          subject: "ALERT! LogRocket initialisation error: " + e.message,
          body: "ALERT! LogRocket initialisation error: " + e.message,
        };

        Parse.Cloud.run("sendEmail", params);
      }
    },
    startParse(){
      Parse.serverURL = "https://parseapi.back4app.com/";
      Parse.initialize(this.appId, this.appJSKey);
      console.log("initialised Parse");
    },
    checkUrlParams() {
      console.log('=== CHECKING URL PARAMS ===');
      console.log('Full URL:', window.location.href);
      console.log('Vue Route:', this.$route);
      
      // Method 0: Check Vue Router query params (PRIMARY - this is where they'll be)
      let routeParamValue = null;
      if (this.$route && this.$route.query) {
        routeParamValue = this.$route.query.donew;
        console.log('Method 0 - Vue Router query (PRIMARY):', routeParamValue);
        console.log('Full route query:', this.$route.query);
      }
      
      // Method 1: Check URLSearchParams from window.location
      const urlParams = new URLSearchParams(window.location.search);
      const urlParamValue = urlParams.get('donew');
      console.log('Method 1 - URLSearchParams:', urlParamValue);
      
      // Method 2: Check hash location for query params
      const hash = window.location.hash;
      console.log('Hash:', hash);
      let hashParamValue = null;
      if (hash.includes('?')) {
        const hashParams = new URLSearchParams(hash.split('?')[1]);
        hashParamValue = hashParams.get('donew');
        console.log('Method 2 - Hash params:', hashParamValue);
      }
      
      console.log('BEFORE setting - this.useNewOrderForm:', this.useNewOrderForm);
      console.log('Setting based on:', { routeParamValue, urlParamValue, hashParamValue });
      
      // Set useNewOrderForm if any method finds donew=true
      // Handle both boolean true and string 'true'
      // Check Vue Router query first as it's the most reliable in your setup
      this.useNewOrderForm = routeParamValue === 'true' || routeParamValue === true ||
                            urlParamValue === 'true' || urlParamValue === true || 
                            hashParamValue === 'true' || hashParamValue === true;
      
      console.log('AFTER setting - this.useNewOrderForm:', this.useNewOrderForm);
      
      console.log('Final useNewOrderForm value:', this.useNewOrderForm);
      console.log('=========================');
    }
  },
  created() {
    console.log("creating me!");
    console.log("Route object:", this.$route);
    console.log("Full URL:", window.location.href);
    
    this.checkUrlParams();
    
    this.deployLogRocket();
    document.body.style.maxWidth = "100vw";
    this.doSetMetas();

    const fromScreen =
      this.$route.params !== undefined
        ? " from " + this.$route.params.fromScreen
        : this.fromScreen !== undefined
        ? this.fromScreen
        : "";

    let referrerURL =
      window.localStorage.getItem("referrerURL") !== null
        ? window.localStorage.getItem("referrerURL")
        : "";

    var extraMsg = "";

    if (window.localStorage.getItem("isnhbfmember") !== null) {
      window.localStorage.removeItem("isnhbfmember");
      this.nhbfmembers = true;
      extraMsg = "FOR NHBF MEMBER ";
    }
    shared.saveToUserPath(
      this.devEnv,
      "Get tips start process " + extraMsg + new Date().toISOString(),
      this.globalPushForwardInterval
    );
    this.doFontSizeComputed();
    window.addEventListener("resize", this.doFontSizeComputed);
  },
  mounted() {
    console.log("MOUNTME!");
    // Check URL params again in mounted hook in case routing happened after created
    this.checkUrlParams();
    window.setTimeout(this.startParse, 1000);
    this.attachBlurZoomReset();
    window.scrollTo(0, 0);

  },
  beforeUnmount() {
    this.hasMountedWalletButton = false;
    this.hasBoundWalletHandler = false;
    this.cardElement = null;
    this.stripe = null;
    this.prButton = null;
    this.paymentRequest = undefined;
    this.elements = null;
  },
  watch: {
      totalItems() {
          this.tryInitStripeOnce();
      },
      useNewOrderForm() {
          this.tryInitStripeOnce();
          this.attachBlurZoomReset(); // re-attach when form swaps
      },
      showPaymentStep() {
          this.tryInitStripeOnce();
          this.attachBlurZoomReset(); // re-attach when form swaps
      },
      showOrderReview() {           // ← add this
          this.attachBlurZoomReset();
      },
      grandTotal() {
        if (this.showPaymentStep === true) {
            this.updateWalletTotalIfAny();
        }
      },
  },
};
</script>

<style>

html, body{
  overflow-x: hidden !important;
  max-width: 100vw !important;
  touch-action: pan-y;
}

/* NEW ORDER FORM STYLES */
.new-order-form-container {
  width: 100%;
  max-width: 800px;
  margin: 3vw auto;
  padding: 0 16px;
}

.new-order-form {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 20px;
  padding: clamp(20px, 4vw, 40px);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.form-title {
  font-family: 'Georgia', serif;
  font-size: clamp(24px, 5vw, 32px);
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: clamp(20px, 4vw, 32px);
  text-align: center;
  letter-spacing: -0.5px;
}

.order-items {
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 2vw, 16px);
  margin-bottom: clamp(20px, 3vw, 24px);
}

/* MOBILE-FIRST: Vertical Stack Layout */
@media (max-width: 575.98px) {
  .order-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: clamp(12px, 3vw, 16px);
    background: white;
    border-radius: 12px;
    padding: clamp(16px, 4vw, 20px);
    border: 2px solid #e5e7eb;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .item-image {
    flex-shrink: 0;
    width: clamp(100px, 25vw, 120px);
    height: clamp(100px, 25vw, 120px);
    border-radius: 12px;
    overflow: hidden;
    background: #f3f4f6;
    margin-bottom: 8px;
    transition: transform 0.2s;
  }

  .item-image:hover {
    transform: scale(1.05);
  }

  .item-details {
    flex: none;
    width: 100%;
    min-width: 0;
  }

  .item-name {
    font-family: 'Georgia', serif;
    font-size: clamp(18px, 4.5vw, 22px);
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px 0;
  }

  .item-description {
    font-size: 16px;
    color: #6b7280;
    margin: 0 0 8px 0;
    line-height: 1.5;
  }

  .item-price {
    font-size: clamp(16px, 4vw, 20px);
    font-weight: 700;
    color: #6366f1;
    margin-bottom: 12px;
  }

  .item-controls {
    display: flex;
    align-items: center;
    gap: clamp(10px, 2.5vw, 12px);
    flex-shrink: 0;
    justify-content: center;
  }

  .qty-btn {
    width: clamp(44px, 11vw, 48px);
    height: clamp(44px, 11vw, 48px);
    border: none;
    border-radius: 12px;
    background: #6366f1;
    color: white;
    font-size: clamp(20px, 5vw, 24px);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qty-display {
    font-size: clamp(18px, 4.5vw, 22px);
    font-weight: 600;
    color: #1a1a1a;
    min-width: clamp(32px, 8vw, 40px);
    text-align: center;
  }
}

/* DESKTOP: Horizontal Row Layout */
@media (min-width: 576px) {
  .order-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: clamp(12px, 2vw, 16px);
    background: white;
    border-radius: 12px;
    padding: clamp(12px, 2vw, 16px);
    border: 2px solid #e5e7eb;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .item-image {
    flex-shrink: 0;
    width: clamp(60px, 15vw, 80px);
    height: clamp(60px, 15vw, 80px);
    border-radius: 8px;
    overflow: hidden;
    background: #f3f4f6;
    transition: transform 0.2s;
  }

  .item-image:hover {
    transform: scale(1.05);
  }

  .item-details {
    flex: 1;
    min-width: 0;
    text-align: left;
  }

  .item-name {
    font-family: 'Georgia', serif;
    font-size: clamp(16px, 3vw, 16px);
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 4px 0;
  }

  .item-description {
    font-size: clamp(16px, 2.5vw, 13px);
    color: #6b7280;
    margin: 0 0 6px 0;
    line-height: 1.4;
  }

  .item-price {
    font-size: clamp(16px, 2.8vw, 15px);
    font-weight: 700;
    color: #6366f1;
  }

  .item-controls {
    display: flex;
    align-items: center;
    gap: clamp(6px, 1.5vw, 8px);
    flex-shrink: 0;
  }

  .qty-btn {
    width: clamp(32px, 8vw, 36px);
    height: clamp(32px, 8vw, 36px);
    border: none;
    border-radius: 8px;
    background: #6366f1;
    color: white;
    font-size: clamp(16px, 4vw, 20px);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qty-display {
    font-size: clamp(16px, 3.5vw, 16px);
    font-weight: 600;
    color: #1a1a1a;
    min-width: clamp(20px, 5vw, 24px);
    text-align: center;
  }
}

/* SHARED STYLES FOR ALL SCREEN SIZES */
.order-item:hover {
  border-color: #6366f1;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);
  transform: translateY(-2px);
}

.order-item.item-selected {
  border-color: #6366f1;
  background: linear-gradient(135deg, #faf5ff 0%, #ffffff 100%);
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qty-btn:hover:not(:disabled) {
  background: #4f46e5;
  transform: scale(1.05);
}

.qty-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.qty-btn:disabled {
  background: #e5e7eb;
  cursor: not-allowed;
  opacity: 0.5;
}

.order-summary {
  background: linear-gradient(135deg, #faf5ff 0%, #f3f4f6 100%);
  border-radius: 12px;
  padding: clamp(16px, 3vw, 20px);
  margin-bottom: clamp(20px, 3vw, 24px);
  border: 2px solid #e5e7eb;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: clamp(13px, 3vw, 15px);
  color: #6b7280;
  margin-bottom: 8px;
}

.summary-row:last-child {
  margin-bottom: 0;
}

.total-row {
  padding-top: 12px;
  border-top: 2px solid #e5e7eb;
  margin-top: 8px;
  font-size: clamp(15px, 3.5vw, 18px);
  font-weight: 600;
  color: #1a1a1a;
}

.total-amount {
  font-size: clamp(18px, 4vw, 24px);
  color: #6366f1;
  font-weight: 700;
}

.config-section,
.contact-section {
  margin-bottom: clamp(20px, 3vw, 24px);
}

.config-title {
  font-family: 'Georgia', serif;
  font-size: clamp(16px, 3.5vw, 18px);
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: clamp(12px, 2vw, 16px);
}

.config-select,
.config-input,
.config-textarea {
  width: 100%;
  padding: clamp(12px, 2.5vw, 14px);
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 16px !important;
  color: #1a1a1a;
  background: white;
  margin-bottom: clamp(10px, 2vw, 12px);
  transition: all 0.2s;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.config-select:focus,
.config-input:focus,
.config-textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.config-textarea {
  min-height: clamp(80px, 15vw, 100px);
  resize: vertical;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.privacy-note {
  font-size: clamp(11px, 2.5vw, 13px);
  color: #6b7280;
  margin: clamp(8px, 1.5vw, 12px) 0 0 0;
  text-align: center;
}

.submit-order-btn {
  width: 100%;
  padding: clamp(14px, 3vw, 18px);
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  font-size: clamp(15px, 3.5vw, 18px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
  margin-bottom: clamp(12px, 2vw, 16px);
}

.submit-order-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.submit-order-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-order-btn:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
  box-shadow: none;
}

.contact-help {
  font-size: clamp(12px, 2.8vw, 14px);
  color: #6b7280;
  text-align: center;
  margin: 0;
  line-height: 1.6;
}

.contact-help a {
  color: #6366f1;
  text-decoration: none;
  font-weight: 500;
}

.contact-help a:hover {
  text-decoration: underline;
}

/* EXISTING STYLES */
@media (max-width: 575.98px) {
  .hairdresser2imagewidth {
    width: 100%;
  }

  .productImageWidth {
    width: 80%;
  }

  .productImageWidthCountertop {
    width: 80%;
  }

  .discreetpackagephonewidth {
    margin: auto !important;
    width: 90vw !important;
  }

  .orderformphonewidth {
    margin: auto !important;
    width: 90vw !important;
  }

  .tugettipspagebuttonwidth {
    width: 80% !important;
  }

  .tugettipspage-textbox {
    margin: auto;
    font-size: 16px;
    height: clamp(24px, 5vh, 34px);
    padding-left: 12px;
    border:0.3px solid #b9b9c0;
    border-radius: 10px;
  }
}

@media (min-width: 576px) {
  .hairdresser2imagewidth {
    width: 80%;
  }

  .productImageWidth {
    width: 80%;
  }

  .productImageWidthCountertop {
    width: 83%;
  }

  .tugettipspagebuttonwidth {
    width: 50% !important;
  }

  .tugettipspage-textbox {
    margin: auto;
    font-size: 16px;
    height: 5vh;
    padding-left: 12px;
    border:0.3px solid #b9b9c0;
    border-radius: 10px;
  }
}

/* IMAGE LIGHTBOX STYLES */
.image-lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.image-lightbox-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
}

.lightbox-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
  color: #333;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 10001;
}

.lightbox-close-btn:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

/* Fade transition for lightbox */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.item-image {
  transition: transform 0.2s;
}

.item-image:hover {
  transform: scale(1.05);
}

/* Apple Pay / Google Pay Button Styling */
#payment-request-button {
  height: 44px;
}

#payment-request-button button {
  height: 44px !important;
  border-radius: 10px !important;
}

.order-complete-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 14px 0;
}

.order-complete-card {
  width: 91%;
  max-width: 520px;
  border: 0.3px solid #b9b9c0;
  border-radius: 10px;
  background: #ffffff;
  padding: 14px;
  box-sizing: border-box;
}

.order-complete-title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 6px;
}

.order-complete-sub {
  font-size: 14px;
  color: #444;
  margin-bottom: 12px;
}

.order-complete-ref {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f5f5f7;
}

.order-complete-ref-label {
  font-size: 13px;
  color: #555;
}

.order-complete-ref-value {
  font-weight: 700;
  font-size: 14px;
}


/* Premium processing overlay */
.tu-paying-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);

  border-radius: 12px;
}

.tu-paying-card {
  width: min(360px, 90%);
  background: #fff;
  border: 1px solid rgba(17, 24, 39, 0.10);
  border-radius: 16px;
  padding: 16px 16px;
  box-shadow: 0 18px 50px rgba(17, 24, 39, 0.14);
}

.tu-paying-top {
  display: flex;
  gap: 12px;
  align-items: center;
}

.tu-paying-text {
  text-align: left;
}

.tu-paying-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.tu-paying-sub {
  margin-top: 4px;
  font-size: 13px;
  color: rgba(17, 24, 39, 0.60);
  line-height: 1.35;
}

.tu-paying-hint {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(17, 24, 39, 0.08);
  font-size: 13px;
  color: rgba(17, 24, 39, 0.70);
}

/* Spinner */
.tu-spinner {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 3px solid rgba(17, 24, 39, 0.14);
  border-top-color: rgba(17, 24, 39, 0.62);
  animation: tuSpin 0.9s linear infinite;
  flex: 0 0 34px;
}

@keyframes tuSpin {
  to { transform: rotate(360deg); }
}
</style>